export default "__VITE_ASSET__GjtMgjzU__"